// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"517":"16c59d6d","818":"272b7b84","936":"04620fc0"}[chunkId] + ".chunk.js";
};